import { useSetDefaultTranslation } from 'api/translations';
import { CustomDeleteModal } from 'components/modal';
import { useTranslationStore } from 'store/translationStore';
import useCustomToast from 'utils/use-toast';

function DefaultModal({
  isOpen,
  onClose,
}: {
  onClose: () => void;
  isOpen: boolean;
}) {
  const setDefaultTranslation = useSetDefaultTranslation();
  const toast = useCustomToast();
  const { translation } = useTranslationStore(state => state);

  const handleSubmit = () => {
    setDefaultTranslation.mutate(
      {
        translationId: translation.id,
      },
      {
        onSuccess: () => {
          toast.success('Translation made default successfully');
          onClose();
        },
        onError: (error: any) => {
          toast.showError(error);
        },
      },
    );
  };

  return (
    <CustomDeleteModal
      isOpen={isOpen}
      onClose={onClose}
      loading={setDefaultTranslation.isLoading}
      handleSubmit={handleSubmit}
      heading={'Default Translation'}
      text={`Are you sure to make this translation default?`}
      primaryButtonText={'Make Default'}
      textClassName={'text-green-370'}
      primaryButtonClassName={
        'bg-green-750 text-green-20 disabled:bg-green-750/60'
      }
      loadingStrokeColor="#8AFF88"
    />
  );
}

export default DefaultModal;
